import './static/css/banner.css';

const Banner = () => {
     return (
          <div class="banner h-75 w-100">
               <div class="position-relative px-4 py-5 start-50 text-center top-50 translate-middle">
                    <h1 class="display-5 fw-bold text-white title">
                         A certeza da melhor tecnologia
                    </h1>
                    <div class="col-lg-6 mx-auto">
                         <p class="lead mb-4 text-light">
                              As melhores solu&ccedil;&otilde;es para a rotina do seu laborat&oacute;rio de an&aacute;lises cl&iacute;nicas
                         </p>
                         <div class="d-grid d-sm-flex gap-2 justify-content-sm-center">
                              <a href="#">
                                   <button class="border-0 btn btn-lg btn-primary px-4 py-3 rounded-pill" type="button">
                                        <i class="bi bi-code" /> Conhe&ccedil;a a solu&ccedil;&atilde;o Madya
                                   </button>
                              </a>
                              <a href="#">
                                   <button class="border-0 btn btn-lg btn-outline-light px-4 py-3 rounded-pill" type="button">
                                        Saiba mais
                                   </button>
                              </a>
                         </div>
                    </div>
               </div>
          </div>
     );
}

export default Banner;